export const buildSubmissionListFromGroupedSubmissions = groupedSubmissions =>
  Object.values(groupedSubmissions).reduce(
    (acc, v) => (v && Array.isArray(v) ? [...acc, ...v] : acc),
    [],
  );
